<template>
    <div class="login-common">
        <div class="warp-login" @keyup.enter="goHome">
            <div v-show="loading">
                <img class="logo-img" v-if="$isAis" src="@/assets/img/login/aisfibre.png" alt="logo">
                <img class="logo-img" v-else-if="isTOT" src="@/assets/img/login/tot.png" alt="logo">
                <img class="logo-img" v-else src="@/assets/img/login/logo.jpg" alt="logo">
            </div>
            
            <h3 class="text-center text_center">SIGN IN</h3>
            
            <div class="form-group">
                <p class="title">USERNAME</p>
                <input v-model="username" v-focus type="text" class="input-form-login username" placeholder="USERNAME">
            </div>
            <div class="form-group">
                <p class="title">PASSWORD</p>
                <input v-model="password"  type="password" class="input-form-login password" placeholder="PASSWORD" auto-complete="new-password">
            </div>

            <div v-if="isShowCaptcha">
                <!-- 验证码 -->
                <div class="text-center">
                    <canvas width="220" height="60" id="captcha" @click="changeCaptcha"></canvas>
                </div>

                <!-- 验证码输入框 -->
                <div class="form-group">
                    <p class="title">VERIFICATIONCODE</p>
                    <input v-model="verificationcode" type="text" class="input-form-login captcha">
                </div>
            </div>
            

            <p v-if="isShow" class="errorText">{{errorText}}</p>

            <div class="text-center text_center">
                <button class="btn-signin" @click="goHome">SIGN IN</button>
            </div>
        </div>
    </div>
</template>

<script>
// 密码错误三次标志浏览器存储逻辑，现在统一后台IP判断
// import {LoginErrCountCheck} from './loginErrCountCheck'
import devConfig from '@/devConfig'
import fhMenu from '@/fhMenu'
import { sha256 } from 'js-sha256'
import CreadCaptcha from './totCaptcha'
import initHead from '../../util/setHead'

export default {
    directives: {
        focus: {
            // 指令的定义
            inserted: function (el) {
            el.focus()
            }
        }
    },
    data() {
        return {
            username: "",
            password: "",
            errorText:"",
            isShow:false,
            isShowCaptcha:false,
            verificationcode:"",
            rdmVal:"",
            isShowCaptcha:false, // 是否显示验证码
            isTOT:false,
            loading:false,
            area: ""
        }
    },
    mounted() {
        this.loading = false
        devConfig.init(this, () => {
            // 仅TOT 版本需要验证码
            this.loading = true
            this.area = devConfig.getData().area;
            if(this.area === 'TOT')
            {
                this.isShowCaptcha = true
                this.isTOT = true
                
                initHead.includeIcon('/faviconTOT.ico')
                initHead.setTitle('TOT')
            }

            this.$nextTick(function () {
                if(this.isShowCaptcha) this.rdmVal = CreadCaptcha("#captcha")
            })
            
            
        })
        
    },
    methods: {
        goHome () {
            this.isShow = false;
            if(this.username === "" || this.password === "")
            {
                this.isShow = true
                this.errorText = "The name or password can not empty!"
                return
            }

            if(this.isShowCaptcha)
            {
                if(this.verificationcode === "")
                {
                    this.isShow = true
                    this.errorText = "The verificationcode can not empty!"
                    return
                }
                else
                {
                    //验证码不为空
                    if(this.verificationcode.toLowerCase()  == this.rdmVal.toLowerCase())
                    {
                        this.$router.push('/home');
                    }
                    else
                    {
                        this.isShow = true;
                        this.errorText = "The verificationcode is Error!";
                        return;
                    }
                }
            }
            

            axios.post('/JSONAPI',{
                cmdType:'SET_WEB_LOGIN',
                username:this.username,
                password:sha256.hmac('fiberhome',this.password)
            })
            .then((response) =>{
                if(response.data.ret != 0)
                {
                    this.loginError(response.data)
                }
                else
                {
                    this.loginSuccess(response)
                }
            })
            .catch( (error) =>{
                this.$message.error("Error! please check network connection.")
            })
        },
        loginError(data) {

            this.isShow = true

            if(data.errCode === 3)
            {
                if(this.isTOT) // TOT 
                    this.haveUserLogin()
                else
                    if (this.area == "CIK" || this.area == "TM") {
                        this.haveUserLoginDo();
                    }else {
                        this.errorText = `Login failed,the user have logined.please wait for ${data.waitTime} seconds!`
                    } 
            }
            else if(data.errCode === 4)
            {
                this.errorText = "Login error! You do not have permission to login."
            }
            else if(data.errCode === 7)
            {
                this.errorText = `Sorry,you have tried more than 3 times, Please try again after ${data.waitTime / 60} minute.`
            }
            else
            {
                this.errorText = "The name or password is wrong!"
            }
        },
        changeCaptcha(){
            this.rdmVal = CreadCaptcha("#captcha",true)
        },
        loginSuccess(response){
            if(process.env.NODE_ENV !== 'production')
            {
                cookie.clear()
                cookie.setItem('userType', response.data.userType + '')
                cookie.setItem('username', response.data.username)
                cookie.setItem('uuid', response.data.uuid)
            }
            
            // 更新设备能力集 用户
            let config = devConfig.getData()
            config.userType = response.data.userType
            devConfig.update(config)

            // 初始化菜单
            fhMenu.init()
            
            // 跳转到首页
            this.$router.push('/home')
        },
        haveUserLogin(){ // 已有用户登录确认
            this.$confirm('The current user is logged in. Do you want to log off and log in again?', 'Tips', {
                confirmButtonText: 'confirm',
                cancelButtonText: 'cancel',
                type: 'warning'
            }).then(() => {
                this.haveUserLoginDo();
            })
        },
        haveUserLoginDo() {
            axios.post('/JSONAPI',{
                cmdType:'SET_WEB_HAVEUSER_LOGIN',
                username:this.username,
                password:sha256.hmac('fiberhome',this.password)
            })
            .then((response) =>{
                if(response.data.ret != 0)
                {
                    this.loginError(response.data)
                }
                else
                {
                    this.loginSuccess(response)
                }
            })
            .catch( (error) =>{
                this.$message.error("Error! please check network connection.")
            })
        }
    }
}

</script>

<style src="@/assets/style/index.css"></style>
<style src="@/assets/style/login.scss" lang="scss"></style>

<style lang="scss" scoped>
.input-form-login.captcha{
    padding-left: 12%;
}
#captcha{
    cursor: pointer;
}
</style>

